<!--
 * @created on 2018/11/8
 * @author LaiXinYu <laixinyualex@gmail.com>
-->

<template>
    <div class="container">
        <div class="wants-label">想去{{ location }}的人({{ total }})</div>
        <div class="wants-list"
             v-infinite-scroll="handlePageUp"
             :infinite-scroll-distance="50"
             :infinite-scroll-disabled="end || loading">
            <user-info v-for="user in list" :userInfo="user" :key="user.userId" :goUserIndex="true"></user-info>
        </div>
        <div class="tips" v-if="loading">正在加载</div>
        <div class="tips" v-if="end">已全部加载</div>
    </div>
</template>

<style scoped lang="scss">
@import "../style/function";

.wants-label {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: px2rem(92);
    background: #fff;
    font-size: px2rem(28);
    font-weight: bold;
    margin-bottom: px2rem(10);
    padding-left: px2rem(32);
}

.tips {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: px2rem(20) 0;
}
</style>

<script>
import Service from "../api/topic";

import UserInfo from "../components/UserInfo/index";

export default {
    name: "Wants",
    components: {
        UserInfo
    },
    data() {
        return {
            topicId: null, // 主题ID
            location: null, // 想去的地点
            currentPage: 1,
            pageSize: 30,
            total: 0,
            list: [],
            loading: false, // 是否正在加载
            end: false
        };
    },
    created() {
        this.topicId = this.$route.params.id;
        this.location = this.$route.query.location;

        this.getWants();
    },
    methods: {
        async getWants() {
            this.loading = true;

            const { msg, data, code } = await Service.getLikes({
                topicId: this.topicId,
                pageSize: this.pageSize,
                currentPage: this.currentPage
            });

            if (code === 200) {
                this.list = data.contentList;
                this.total = data.total;
            } else {
                this.$toast.open({ msg });
            }

            if (data.contentList.length < this.pageSize) {
                this.end = true;
            }

            this.loading = false;
        },

        handlePageUp() {
            if (this.end || this.loading) return;

            this.currentPage += 1;

            this.getWants();
        }
    }
};
</script>
